import { render, staticRenderFns } from "./PaoListTabPao.vue?vue&type=template&id=47042b5f&scoped=true"
import script from "./PaoListTabPao.vue?vue&type=script&lang=js"
export * from "./PaoListTabPao.vue?vue&type=script&lang=js"
import style0 from "./PaoListTabPao.vue?vue&type=style&index=0&id=47042b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47042b5f",
  null
  
)

export default component.exports